<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <div class="searchBox clear">
            <div class="search-item">
              <p>用户ID：</p>
              <input type="text" placeholder="请输入要搜索的用户ID" v-model="obj.uid">
            </div>
            <div class="search-item">
              <p>用户昵称：</p>
              <input type="text" placeholder="请输入要搜索的用户昵称" v-model="obj.username">
            </div>
            <div class="search-item">
              <p>用户手机号：</p>
              <input type="text" placeholder="请输入要搜索的用户手机号" v-model="obj.mobile">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="exportUserSub">导出</button>
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.uid">{{item.uid}}</p>
              <p :title="item.username">{{item.username}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p :title="item.channel==1?'app':'百度'">{{item.channel==1?'app':'百度'}}</p>
              <p :title="item.is_member==0?'否':'是'">{{item.is_member==0?'否':'是'}}</p>
              <p :title="item.pay_time">{{item.pay_time}}</p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getUserList,exportUser} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "vip",
  data() {
    return {
      navId:'7',
      childrenID:'7-1',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'用户ID'},
        {id:3,title:'用户昵称'},
        {id:4,title:'手机号'},
        {id:5,title:'注册时间'},
        {id:6,title:'注册渠道'},
        {id:7,title:'是否会员'},
        {id:8,title:'首次付费时间'},
      ],
      dataList:[
      ],
      obj:{
        page:1,
        rows:10,
      },
      token:'',
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.getList();
    console.log(this.$refs.navBox)
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
      };
      this.dataList = [];
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getUserList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async exportUserSub(){
      var that = this;
      var obj = {
        uid:this.obj.uid ? this.obj.uid : '',
        username:this.obj.username ? this.obj.username : '',
        mobile:this.obj.mobile ? this.obj.mobile : '',
      };
      if(obj.uid && obj.username && obj.mobile){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?uid='+obj.uid + '&username=' + obj.username + '&mobile='+obj.mobile;
      } else if(obj.uid && obj.username){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?uid='+obj.uid + '&username=' + obj.username;
      } else if(obj.uid && obj.mobile){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?uid='+obj.uid + '&mobile=' + obj.mobile;
      } else if(obj.username && obj.mobile){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?username='+obj.username + '&mobile=' + obj.mobile;
      } else if(obj.username){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?username='+obj.username;
      } else if(obj.uid){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?uid='+obj.uid;
      } else if(obj.mobile){
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser?mobile='+obj.mobile;
      } else {
        window.location.href = this.$refs.navBox.url + 'admin/User/exportUser';
      }
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 8 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.searchBox>>>.search-item input{
  width: 200px;
}

.msgBox .contv{
  height: 80%;
}

.msgBox .btnBox{
  margin-top: 50px;
}

.msgBox>>>.el-radio__label{
  font-size: 15px;
}
.msgBox>>>.el-radio-group .el-radio{
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/user/info.vue